import React, { Component } from 'react';
import 'ag-grid-enterprise';
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import loading from '../../assets/images/excelforce-logo-only.png';

class Grid extends Component {
  constructor(props) {
    super(props);
    this.height = this.props.height || '100%';
  }
  state = {
    overlayLoadingTemplate:
      `<span class="__loader"> <img src=${loading}></img></span>`,
    overlayNoRowsTemplate:
      '<span style="padding: 10px;">No Record Found</span>',
    defaultColDef: {
      sortable: true,
      resizable: true,
      filter: true,
    },
    rowHeight: 35,
    AutoSizeStrategy: {
      type: 'fitCellContents',
      skipHeader: false
    },
    statusBar: {
      statusPanels: [
        { statusPanel: 'agTotalAndFilteredRowCountComponent' },
        { statusPanel: 'agTotalRowCountComponent' },
        { statusPanel: 'agFilteredRowCountComponent' },
        { statusPanel: 'agSelectedRowCountComponent' },
        { statusPanel: 'agAggregationComponent' }
      ]
    }
  }

  render() {
    const { rowHeight, overlayLoadingTemplate, overlayNoRowsTemplate, AutoSizeStrategy, statusBar, ...rest } = this.state
    const {
      autoGroupColumnDef,
      autoSizeStrategy,
      cacheOverflowSize,
      columnDefs,
      filter,
      frameworkComponent,
      getRowStyle,
      groupDefaultExpanded,
      groupDisplayType,
      groupMultiAutoColumn,
      groupTotalRow,
      infiniteInitialRowCount,
      maxBlocksInCache,
      onCellValueChanged,
      onFirstDataRendered,
      onGridReady,
      paginationPageSize,
      pinnedBottomRowData,
      pinnedTopRowData,
      pivotMode,
      pivotPanelShow,
      rowData,
      rowGroupPanelShow,
      rowModelType,
      sideBar,
      showStatusBar,
      suppressAggFuncInHeader,
      ...otherProps
    } = this.props
    return (
      <div className="ag-theme-alpine" style={{ height: this.height, width: '100%' }}>

        <AgGridReact
          autoGroupColumnDef={autoGroupColumnDef}
          autoSizeStrategy={autoSizeStrategy || AutoSizeStrategy}
          cacheOverflowSize={cacheOverflowSize}
          columnDefs={columnDefs}
          debounceVerticalScrollbar={true}
          defaultColDef={{ ...this.state.defaultColDef, ...(this.props.defaultColDef || {}) }}
          enableFilter={true}
          enableRangeHandle={true}
          enableRangeSelection={true}
          filter={filter}
          frameworkComponents={frameworkComponent}
          getRowStyle={getRowStyle}
          groupDefaultExpanded={groupDefaultExpanded}
          groupDisplayType={groupDisplayType}
          groupMultiAutoColumn={groupMultiAutoColumn}
          groupTotalRow={groupTotalRow}
          infiniteInitialRowCount={infiniteInitialRowCount}
          maxBlocksInCache={maxBlocksInCache}
          onCellValueChanged={onCellValueChanged}
          onFirstDataRendered={onFirstDataRendered}
          onGridReady={onGridReady}
          overlayLoadingTemplate={overlayLoadingTemplate}
          overlayNoRowsTemplate={overlayNoRowsTemplate}
          paginationPageSize={paginationPageSize}
          pinnedBottomRowData={pinnedBottomRowData}
          pinnedTopRowData={pinnedTopRowData}
          pivotMode={pivotMode}
          pivotPanelShow={pivotPanelShow}
          rowData={rowData}
          rowGroupPanelShow={rowGroupPanelShow}
          rowHeight={rowHeight}
          rowModelType={rowModelType || 'clientSide'}
          sideBar={sideBar}
          statusBar={showStatusBar ? statusBar : undefined}
          suppressAggFuncInHeader={suppressAggFuncInHeader}
          {...otherProps}
        >
        </AgGridReact>
      </div>

    );
  }
}
export default Grid;
